<template>
    
    <svg version="1.1" viewBox="0 0 800 800" width="1280" height="1280" xmlns="http://www.w3.org/2000/svg">
<path transform="translate(418,9)" d="m0 0h73l8 1 1 1v57l-3 1-31 2h-13v27l-1 15 8-1 55-1h29l3 1 1 2v22l-3 3-29 1h-15l1 52-1 271-2 10-8 14-4 5-10 7-10 5-6 1 1 82-4 3-12 2h-3l1 16v23l-4 7-11 6-4 1-1 130-7 7-1 2-5-1-4-6-3-6-1-15v-112l-6-1-8-5-5-6-1-3v-37l-11-2-6-3-2-2-1-12v-69l-6-2-10-6-7-6-10-14-3-7-2-11v-66l1-60v-32l-2-156 1-4h-48l-1-2 3-25 1-1 94-1v-38l-5-2-11-1-30-1-1-1v-55l1-2zm-24 23-41 1v14l8 1h39l73-1-1-15zm7 40-1 3v37h26l-1-39-3-1zm-23 67-26 1v27l3 1h94l26-1v-27zm-30 41v14h127l1-12-1-2zm4 64v213l3 7 7 8 7 7h88l9-6 9-10v-219h-30l-1 2v162l-64-1-1-163zm40 261-1 8 1 54h44l-1-62zm13 87v23l14 1 2-1v-23z"/>
<path transform="translate(124,198)" d="m0 0 103 1 21 5 16 7 18 12 10 10 8 13 7 14 5 17 1 11v27l-1 11-6 18-7 13-10 14-11 12-15 11-19 9-21 5-25 1h-73l-2-2v-207zm53 50-1 55v56h43l12-5 11-7 8-9 6-13 3-10v-24l-6-16-7-10-8-7-12-6-11-3-9-1z"/>
<path transform="translate(532,202)" d="m0 0 111 1 9 2 16 8 11 7 9 9 8 13 4 10 2 13v15l-3 15-8 16-11 13-9 8-14 7-15 4-9 1h-48v67l-1 1h-52l-1-3v-205zm53 50-1 43 3 1h34l13-1 9-7 4-6 1-8-2-8-4-6-7-6-8-2z"/>
<path transform="translate(386,428)" d="m0 0h44l13 1 1 1v22l-62 1-3-1v-21l1-2z"/>
<path transform="translate(451,695)" d="m0 0h11l10 5 7 8 1 5-6 8-7 7-5 3-7 1-9-4-5-4-5-9 1-7 5-8 6-4z"/>
<path transform="translate(687,368)" d="m0 0h7l5 2 1 3-2 11h14l1 1-1 10-2 2h-12v14l-2 2-6 1-3-2-1-11-1-3h-15l-3-4 1-9 2-1h16z"/>
</svg>

    
      </template>
      
      <script>
      export default {}
      </script>
      
      <style></style>
      